import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex, Input, Text } from '@chakra-ui/react'
import moment from 'moment'
import { TooltipCell, NormalTextCellRenderer } from '@/components/Table/components/Cell/ToolTipCell'
import DatePicker from 'react-datepicker'
import { useEffect, useState } from 'react'

const DatePickerCell = ({
  getValue,
  table,
  row: { index: rowIndex },
  column: { id: columnId },
  extraDisable = false,
  maxDate,
}) => {
  const rowValue = getValue()
  const isDisabled = table.options.meta?.disabled || extraDisable

  const onChange = (value) => {
    table.options.meta?.updateData(rowIndex, columnId, value)
  }

  if (isDisabled) {
    const date = rowValue ? moment(rowValue) : null

    return <Text>{date && date.isValid() ? date.format('DD-MMM-YYYY') : '(-)'}</Text>
  }
  return (
    <Input
      as={DatePicker}
      dateFormat={'dd-MMM-yyyy'}
      selected={rowValue ? new Date(rowValue) : undefined}
      onChange={onChange}
      showYearDropdown
      showMonthDropdown
      yearDropdownItemNumber={15}
      scrollableYearDropdown
      maxDate={maxDate ? new Date(maxDate) : undefined}
      popperPlacement="bottom-end"
      popperModifiers={[
        {
          name: 'preventOverflow',
          options: {
            rootBoundary: 'viewport',
            tether: false,
            altAxis: true,
          },
        },
      ]}
    ></Input>
  )
}

export default DatePickerCell
